import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getMetricsByJobId,
  installerTestsReducer
} from './../reducers';
import { installer as installerHelpers } from './../helpers';
import InstallerTestInfoComponent
  from './../Components/InstallerTestInfoComponent.jsx';

export const mapStateToProps = (state, ownProps) => {
  const installerTestExpectedByRunner = installerTestsReducer.installerTestExpectedByRunner(state);
  const scenarioRunner = ownProps.scenarioRunner;
  const runnerExpectedTests = installerTestExpectedByRunner[scenarioRunner] || [];
  const badPrePack = runnerExpectedTests.some(testExpected =>
    testExpected.Presence === installerHelpers.MISSING_PREPACK_PRESENCE);
  const badPostPack = runnerExpectedTests.some(testExpected =>
    testExpected.Presence === installerHelpers.MISSING_POSTPACK_PRESENCE
  );

  return {
    metrics: getMetricsByJobId(state, ownProps.jobId) || {},
    installerTestExpectedByRunner: installerTestsReducer.installerTestExpectedByRunner(state),
    scenarioStatus: ownProps.scenarioStatus,
    badPrePack: badPrePack,
    badPostPack: badPostPack,
    title: ownProps.title
  };
};

const InstallerTestInfoContainer = connect(
  mapStateToProps
)(InstallerTestInfoComponent);

InstallerTestInfoContainer.propTypes = {
  jobId: PropTypes.number.isRequired,
  scenarioStatus: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

export default InstallerTestInfoContainer;


// WEBPACK FOOTER //
// src/Containers/InstallerTestInfoContainer.jsx